import axios from "axios"

export const buildHeaders = ({ token = null }) => (
  {
    authorization: `Bearer ${token}`
  }
)

export class ClientHelper {
  static get cancelToken() {
    return axios.CancelToken.source()
  }
}